import {attributeStore} from './attributes.js';
import {errorStore} from './errors.js';
import {settingsStore} from './settings.js';
import {uiStore} from './ui.js';

export const journeyStore = {
  ui: uiStore,
  errors: errorStore,
  attributes: attributeStore,
  settings: settingsStore,
};
